import { useView } from '@10000/react'
import { TooltipDialog } from '../../widgets'
import { isFree } from '../../../lookups'
import { useAnalyticsData } from '../AnalyticsData.jsx'

export const CompareDialogs = () => {
  const { subscription } = useView('tenant')
  const freeSquiz = isFree(subscription)
  const { active } = useAnalyticsData()

  return (
    <>
      <TooltipDialog
        order={0}
        title="Compare Your Results"
        text="Use these filters to benchmark your analytics against global data."
        image="filters"
        buttonText="Next"
      />
      <TooltipDialog
        order={2}
        title="Dive Into the Details"
        text="Click any practice of the chart view side-by-side comparisons"
        image="deep-dive"
        buttonText="Next"
      />
      {(!freeSquiz || active.consensus?.some(x => !!x)) && <TooltipDialog
        order={4}
        title="Consensus Mode"
        text="You can compare your results from standard mode to the results obtained in consensus mode."
        image="compare-consensus"
        buttonText="Explore"
      />}
    </>
  )
}